import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  CardContent,
  DialogActions,
  Fab,
  FormControl,
  FormGroup,
  Grid,
  MenuItem,
  Snackbar,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { Search } from "@material-ui/icons";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "./../../components/Dialog";
import SnackbarContent from "./../../components/SnackbarContentWrapper";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps } from "./../../redux/campaigns";

class CampaignAllocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      campaignAllocationId: null,
      limit: null,
      modalConfigGetMore: false,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    await this.itemInit();
  }

  listCollumns = [
    {
      id: "campaign",
      numeric: true,
      disablePadding: false,
      label: "Chiến dịch",
    },
    {
      id: "from",
      numeric: true,
      disablePadding: false,
      label: "Đầu số gọi ra",
    },
    {
      id: "contactFile",
      numeric: true,
      disablePadding: false,
      label: "Nguồn dữ liệu",
    },
    // { id: "filterData", numeric: true, disablePadding: false, label: "Bộ lọc" },
    { id: "type", numeric: true, disablePadding: false, label: "Loại" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
    {
      id: "configGetMoreAction",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({
                    createdAt: {
                      gte: `${this.state.filters.where.from} 00:00:00`,
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    createdAt: {
                      lte: `${this.state.filters.where.to} 23:59:59`,
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getCampaignAllocation(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.getAllCampaigns();
    this.props.countListCampaignsAllocation({ where });
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        campaignConfig: true,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (dateFrom) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(dateFrom, "YYYY-MM-DD");
    this.setState({ dateFrom });
  };

  handleDateChangeEnd = (dateTo) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(dateTo, "YYYY-MM-DD");
    this.setState({ dateTo });
  };

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleOpenModalConfigGetMore = (item) => {
    this.setState({
      campaignAllocation: item,
      modalConfigGetMore: !this.state.modalConfigGetMore,
    });
  };

  handleConfigGetMore = () => {
    this.props.getMoreDataAction(
      this.state.campaignAllocation.id,
      this.state.limit
    );
  };

  handleClose = () => {
    this.setState({ modalConfigGetMore: false, campaignAllocation: {} });
  };

  handleCloseNoti() {
    this.props.openModal && this.props.openModalNotification();
  }

  handleReload = (item) => {
    this.props.reloadCampaigns(item.id, true);
  };

  render() {
    const { classes, listAllocation, listCampaign, newCampaign } = this.props;
    const { filters } = this.state;
    const listAllocationResult =
      typeof listAllocation === "object"
        ? Object.keys(listAllocation).map((key) => listAllocation[key])
        : listAllocation;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center", display: "flex" }}>
                      <Grid item md={2}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tên chiến dịch"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.campaignId}
                          name="campaignId"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listCampaignResult
                            ? listCampaignResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={2}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Nguồn dữ liệu"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.type}
                          name="type"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          <MenuItem key="file" value="file">
                            File danh bạ
                          </MenuItem>
                          <MenuItem key="contact" value="contact">
                            Danh bạ CRM
                          </MenuItem>
                          <MenuItem key="il" value="il">
                            Danh bạ tương tác
                          </MenuItem>
                          {/* <MenuItem key="il" value="il">Danh bạ big data</MenuItem> */}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from ? filters.where.from : null}
                          maxDate={new Date()}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                        />
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to ? filters.where.to : null}
                          maxDate={new Date()}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                        />
                      </Grid>

                      <Grid item md={2}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách phân bổ chiến dịch"
          items={listAllocationResult}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleConfigGetMore={this.handleOpenModalConfigGetMore}
          handleReload={this.handleReload}
        />
        <Dialog
          open={this.state.modalConfigGetMore}
          onClose={this.handleClose}
          title={`Phân bổ thêm dữ liệu từ chiến dịch ${
            this.state.campaignAllocation
              ? this.state.campaignAllocation.campaign
                ? this.state.campaignAllocation.campaign.name
                : ""
              : ""
          }`}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleConfigGetMore}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số lượng dữ liệu"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChange("limit")}
                    value={this.state.limit}
                    name="limit"
                    validators={["required", "minNumber:1", "maxNumber:1000"]}
                    errorMessages={[
                      `Không được để trống`,
                      "Số lớn hơn 1",
                      "Số nhỏ hơn 1000",
                    ]}
                  />
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Snackbar
          open={this.props.openModal}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          onClose={this.handleCloseNoti.bind(this)}
          autoHideDuration={3000}>
          <SnackbarContent
            onClose={this.handleCloseNoti.bind(this)}
            variant={"success"}
            message={`Phân bổ thành công ${
              newCampaign !== undefined ? newCampaign.interacticeLogCount : 0
            } tương tác`}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

CampaignAllocation.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    padding: theme.spacing.unit * 3,
  },
});

const mapStateToProps = (state) => ({
  listAllocation: state.campaign.campaignAllocation,
  listCampaign: state.campaign.allCampaign,
  newCampaign: state.campaign.getMoreData,
  openModal: state.campaign.openModal,
  count: state.campaign.countCampaignAllocation,
});

CampaignAllocation = connect(
  mapStateToProps,
  mapActionsToProps
)(CampaignAllocation);

export default withStyles(styles)(CampaignAllocation);
